// @flow
import Fade from "./Fade";
import SlideUpDown from "./SlideUpDown";

import type { Node } from "react";

export type StyleProps = {
  [key: string]: string | number
};

export type TransitionProps = {
  in?: boolean,
  children: Node | ((style: StyleProps) => Node)
};

export { Fade, SlideUpDown };



// WEBPACK FOOTER //
// ./src/components/common/Animations/index.js